
const getDefaultState = () => {
  return {
    recorded: {
      signupLanguageChoice: 'en',
      progress: {
        step1: false,
        step2: false
      },
      agencyInfo: {
        clientBrandName: ''
      },
      businessInfo: {
        businessName: '',
        country: {
          name: '',
          alpha2: '',
          alpha3: ''
        },
        businessContact: {
          intlCode: '',
          localNumber: ''
        },
        businessEmail: '',
        webAddress: ''
      },
      mainUser: {
        firstName: '',
        lastName: '',
        contactNumber: '',
        emailAddress: ''
      },
      users: [],
      socialMediaReviews: {
        facebook: '',
        twitter: '',
        googleMaps: '',
        trustPilot: '',
        g2: '',
        capterra: '',
        tripAdvisor: '',
        yelp: '',
        fourSquare: '',
        chooseFbS: false,
        chooseFbR: false,
        chooseTw: false,
        chooseGP: false,
        chooseTP: false,
        chooseG2: false,
        chooseCT: false,
        chooseTA: false,
        chooseYE: false,
        chooseFS: false
      },
      needHelpSocialReviews: false,
      needHelpLogoColor: false,
      feedbackAddressHandle: '',
      appearance: {
        logoUrl: '',
        showWhiteLogoBorder: true,
        showWhiteLogoBackground: true,
        backgroundHex: {
          "hsl": {
              "h": 248.82352941176475,
              "s": 0.4788732394366196,
              "l": 0.2784313725490196,
              "a": 1
          },
          "hex": "#2F2569",
          "hex8": "#2F2569FF",
          "rgba": {
              "r": 47,
              "g": 37,
              "b": 105,
              "a": 1
          },
          "hsv": {
              "h": 248.82352941176475,
              "s": 0.6476190476190475,
              "v": 0.4117647058823529,
              "a": 1
          },
          "oldHue": 279.7333333333333,
          "source": "hex",
          "a": 1
          },
      secondaryHex: {
        "hsl": {
            "h": 219.8230088495575,
            "s": 0.6457142857142857,
            "l": 0.3431372549019608,
            "a": 1
        },
        "hex": "#1F4590",
        "hex8": "#1F4590FF",
        "rgba": {
            "r": 31,
            "g": 69,
            "b": 144,
            "a": 1
        },
        "hsv": {
            "h": 219.8230088495575,
            "s": 0.7847222222222222,
            "v": 0.5647058823529412,
            "a": 1
        },
        "oldHue": 248.82352941176478,
        "source": "hex",
        "a": 1
    }
      },
      subscriptionType: ''
    },
    view: {
      currentStep: 1,
      modals: {
        socialMediaHelp: false
      },
      initialSetup: '' // in case it's setup/change, to make sure there's a change
    }
  }

}

export default getDefaultState
